<main class="container-geral">
  <section class="cabecalho">
    <div class="d-flex">
      <h1 class="titulo fonte-DM-Sans">
        {{ 'COMPONENTS.TAXAS_MAPA_LIST.title' | transloco }}
      </h1>
    </div>

    <div class="d-flex gap-2">
      <button *ngIf="permissoes.editar" class="btn-cadastrar-listagem fonte-DM-Sans" [routerLink]="['editar', operacaoId]">
        {{ 'COMPONENTS.TAXAS_MAPA_LIST.editButton' | transloco }}
      </button>

      <button *ngIf="permissoes.criar" class="btn-cadastrar-listagem fonte-DM-Sans" routerLink="cadastro">
        {{ 'COMPONENTS.TAXAS_MAPA_LIST.createButton' | transloco }}
      </button>
    </div>
  </section>

  <section>
    <div class="d-flex justify-content-end gap-4 mb-2 mt-4">
      <div class="container-filtro">
        <object class="icone-caminhao" data="assets/taxas-ideais-mapa/tipos.svg" type="image/svg+xml"></object>
        <select id="filtro-tipo" class="filtro-tipo crud-select form-select" (change)="filtrarPorTipo($event)">
          <option value="todos" selected>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.allTypes' | transloco }}
          </option>

          <option *ngFor="let taxa of tiposTaxas" [value]="taxa.tipo">
            {{ 'ENUMS.taxas_short.' + taxa.tipo | transloco }}
          </option>
        </select>
      </div>

      <app-filtro-clientes (carregarCliente)="buscarOperacoesDisponiveis($event)"></app-filtro-clientes>

      <div class="container-filtro">
        <object class="icone-caminhao" data="assets/taxas-ideais-mapa/operacao-icon.svg" type="image/svg+xml"></object>

        <select id="filtro-operacao" class="filtro-tipo crud-select form-select" (change)="buscarTaxas($event)" [disabled]="!operacoesDisponiveis">
          <option *ngIf="!operacoesDisponiveis" value="null">
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.noOperation' | transloco }}
          </option>

          <option *ngFor="let operacao of operacoesDisponiveis" [value]="operacao.sr_id">
            {{ operacao.vc_service_id | Capitalize }}
          </option>
        </select>
      </div>
    </div>

    <div class="scroll-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-none tabela-operacoes">

        <tr *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="taxa-vazio text-center text-muted">
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.empty' | transloco }}
          </td>
        </tr>

        <ng-container matColumnDef="vc_service_id">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.columns.serviceOrder' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ serviceId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="en_tipo">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.columns.type' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="etiqueta etiqueta-ativo" [style]="'--cor-etiqueta-taxa:' + coresTipos[element.en_tipo]" [matTooltip]="
                'ENUMS.taxas.' + element.en_tipo | transloco
              "
            > {{ 'ENUMS.taxas_short.' + element.en_tipo | transloco }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="fl_minimo_aceitavel">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.columns.minimum' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.fl_minimo_aceitavel }} {{ medidasTaxas[element.en_tipo] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fl_ideal">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.columns.ideal' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="etiqueta etiqueta-ativa">
              {{ element.fl_ideal }} {{ medidasTaxas[element.en_tipo] }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPONENTS.TAXAS_MAPA_LIST.columns.actions' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            <button class="botaoAcao" [matTooltip]="
                'COMPONENTS.TAXAS_MAPA_LIST.tooltips.delete' | transloco
              " (click)="excluir(element.sr_id)"
            >
              <img src="assets/compartilhados/lixeira.svg" alt="Excluir" />
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <app-loading *ngIf="loading" [linhas]="5" [colunas]="1"></app-loading>
  </section>
</main>
